// extracted by mini-css-extract-plugin
module.exports = {"body":"PageWithHeaderAndFooter_body__3UfOK","container":"PageWithHeaderAndFooter_container__kq9qC"};